<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-15 17:16:45
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-05-24 16:48:19
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\components\settingPassWord\index.vue
-->
<template>
    <div>
        <el-dialog 
            center 
            title="修改密码" 
            :visible.sync="DialogChange" 
            destroy-on-close	
            width="500px" 
            :close-on-click-modal='false'
            @close="closeDialog">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" >
                <el-form-item label="旧密码" prop="age">
                    <el-input v-model.number="ruleForm.age"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { api_changepwd } from "@/api/accpwd.js";
import local from "@/utils/local.js";
let Base64 = require('js-base64').Base64
export default {
    name:'SettingPassWord',
    data(){
         var checkAge = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('旧密码不能为空'));
            }else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('不能输入汉字!'));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('不能输入汉字!'));
            } else {
            if (this.ruleForm.checkPass !== '') {
                this.$refs.ruleForm.validateField('checkPass');
            }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('不能输入汉字!'));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return{
            ruleForm: {
                pass: '',
                checkPass: '',
                age: ''
            },
            setPassWordFlag:false,
            rules: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                age: [
                    { validator: checkAge, trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.ruleForm={};
    },
    computed:{
        DialogChange(){
            if(this.$store.state.setPassWordDialog){
                this.ruleForm = {}
                return true
            }else{
                return false
            }
        }
    },
    methods:{
        
        /**
         * @description: 修改密码提交
         * @param {*} ruleForm
         * @return {*}
         */ 
        submitForm(ruleForm) {
            this.ruleForm.checkPass = Base64.encode(this.ruleForm.checkPass)
            this.ruleForm.pass = Base64.encode(this.ruleForm.pass)
            // this.ruleForm.age = Base64.encode(this.ruleForm.age)
            this.$refs[ruleForm].validate(async (valid) => {
                if (valid) {
                    let res = await api_changepwd({
                        confirmPassword:this.ruleForm.checkPass,
                        newPassword:this.ruleForm.pass,
                        oldPassword:Base64.encode(this.ruleForm.age),
                        id:local.get("userid"),
                    });
                    if(res.code == 0){
                        this.$message({
                            message: '密码已修改，请重新登陆',
                            type: 'success'
                        });
                        local.clear();
                        this.$store.commit('setPassWordDialogChange',0)
                        this.$router.push('/login')
                    }else{
                        this.$message.error(res.message);
                    }
                } 
            });
        },
        /**
         * @description: 
         * @param {*}
         * @return {*}
         */    
        closeDialog(){
            this.$store.commit('setPassWordDialogChange',0)
        }
    }
}
</script>
<style scoped lang="less">

</style>